<template lang='pug'>
  .div-main
    strong(:class='{ "hidden-print-only": labelNoPrint }') {{ label }} {{ colon ? ':' : '&nbsp;' }}
      .no-print
        v-checkbox.ma-0.d-inline-block(v-model="data", hide-details, off-icon="print", on-icon="print_disabled", @change="onChangeData")
</template>

<script>
export default {
  name: 'field-btn-print',

  props: {
    label: {
      type: String
    },
    labelNoPrint: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean
    },
    colon: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    value (val) {
      this.data = val
    }
  },

  data () {
    return {
      data: false
    }
  },

  mounted () {
    this.data = this.value
    if (this.print !== undefined) this.data = this.print
  },

  methods: {
    onChangeData (val) {
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style lang='stylus' scoped>
  .div-main
    position relative

  .no-print
    position absolute
    top -18px
    left -18px
    visibility hidden
    transition-duration 0.8s

  .div-main:hover .no-print, .no-print:hover
    visibility visible!important
</style>



// WEBPACK FOOTER //
// src/pages/ultra-fetal/summary/components/FieldBtnPrint.vue